import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#077A97',
        height: 60,
        width: '100%',
        position: 'absolute',
        top: 0,
        zIndex: 999
    },

    content: {
        width: 'auto',
        height: 60,
        paddingLeft: 15,
        paddingRight: 15,
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'space-evenly',
    },

    label: {
        marginTop: -2,
        color: '#FFF',
        fontSize: 14,
    },

    imageLogo:{
        width: 96,
        height: 55.45
    },

    imagePerfil: {
        marginTop: 10,
        width: 40,
        height: 40,
        tintColor: '#FFFFFF'
    },  

    labelActive: {
        marginTop: -2,
        color: '#222',
        fontSize: 14,
        borderStyle: '1px solid #196059',
        borderBottomWidth: '1px',
        borderBottomColor: '#196059',
    },
    tab: {
        textTransform: 'uppercase',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: 10,
        paddingRight: 10,
    }
});

export default styles;
